export default __webpack_public_path__ + "static/media/mobile_11.7cee510d.png";